<div class="card-background-copy">
  <form [formGroup]="registrationDetailForm" autocomplete="off" role="form">
    <div class=" bg-white">
      <div class="col-md-12 wrapperMargin content-wrapper ">

        <div *ngIf="!addressSeachEnabled">
            <div class="col-md-12 clear-all margin-top-30">
                <div class="col-md-5 clear-all">
                    <label for="addressline1"  class="form-label">
                        {{contentData.addressline1}}
                    </label>
                        <input class="form-control"
                        id="addressline1" name="addressline1" placeholder="Please enter"
                        formControlName="addressline1" type="text" 
                        
                        >
                </div>
            </div>
            <div class="col-md-12 clear-all margin-top-30">
              <div class="col-md-5 clear-all">
                  <label for="addressline2"  class="form-label">
                      {{contentData.addressline2}}
                  </label>
                      <input class="form-control"
                      id="addressline2" name="addressline2" placeholder="Please enter"
                      formControlName="addressline2" type="text" 
                      
                      >
              </div>
            </div>
            <div class="col-md-12 clear-all margin-top-30">
              <div class="col-md-5 clear-all">
                  <label for="addressline3"  class="form-label">
                      {{contentData.addressline3}}
                  </label>
                      <input class="form-control"
                      id="addressline3" name="addressline3" placeholder="Please enter"
                      formControlName="addressline3" type="text" 
                      
                      >
              </div>
            </div>
            <div class="col-md-12 clear-all margin-top-30" >
              <div class="col-md-5 clear-all">
                <app-postcode id="postcode" [postCodeConfig]="postCodeConfig" [controlName]="'postcode'" formControlName="postcode" [parent]="registrationDetailForm"
                [required]="'true'" >
                  ></app-postcode>
              </div>
              
            </div>
            <div class="col-md-12 clear-all margin-top-30" style="margin-bottom: 10px !important;">
              <div class="col-md-5 clear-all">
                <app-dropdown [pageName]="'registration'" [dropdownConfig]="countryConfig" 
                [controlName]="'country'"  [parent]="registrationDetailForm">
                </app-dropdown>
              </div>
            </div>
            <p >
                <a id="address-manual" (click)="onAddressSeachClick()" class="clickHere">
                  click here </a>
                to seach for another address   
                </p>
        </div>
        

        <div *ngIf="addressSeachEnabled" >
          <div class="col-md-12 clear-all margin-top-30">
            <div class="col-md-5 clear-all">
              <app-address-search (onSelecteAddress)=onSelecteAddress($event)></app-address-search>
            </div>
          </div>
          <div>
            <p >
              <a id="address-manual" (click)="onManualClick()" class="clickHere">
                click here </a>
                to enter address manually 
              </p>
          </div>
          
        </div>
      </div>

      
    </div>

   
  </form>
</div>
